export enum EnergyUnit {
    KWH = 'kWh',
    MWH = 'MWh',
    M3 = 'm3'
}
